import { render } from "./DireccionesRegistro.vue?vue&type=template&id=6111f3ca"
import script from "./DireccionesRegistro.vue?vue&type=script&lang=js"
export * from "./DireccionesRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__